/* eslint-disable arrow-body-style */
import React from 'react';
import { SearchResults } from '@src/common/FilterPanelPage/results/SearchResults';
import { ResultsExcessive } from '@src/routes/link-analysis/components/resultsComponents/ResultsExcessive';
import { linkAnalysisId } from '../types';
import { Results } from './resultsComponents/Results';
import { useLinkAnalysisResultsStore } from '../mothership/linkAnalysisResults.state';
import { ResultsUnmanageable } from './resultsComponents/ResultsUnmanageable';

export const LinkAnalysisResults = () => {
  const status = useLinkAnalysisResultsStore((state) => state.resultStatus);

  return (
    <SearchResults
      id={linkAnalysisId}
      status={status}
      iconPending="hub"
      SuccessComp={<Results id={linkAnalysisId} />}
      ExcessiveComp={<ResultsExcessive id={linkAnalysisId} />}
      UnmanageableComp={<ResultsUnmanageable id={linkAnalysisId} />}
    />
  );
};
